import styled from 'styled-components';
import { ListItemFooterStyledProps } from './listItemFooter.model';

export const ListItemFooterStyled = styled.div<ListItemFooterStyledProps>`
  width: 100%;
  align-self: flex-end;
`;
